module.exports = __webpack_public_path__ + "img/d11.94fe6e18.jpg";